/**
 * Step 7 · Domain / Wireframe.
 * Shows lithology counts + the Implicit Modelling engine
 * (Leapfrog-style RBF/SDF surface builder from real assay samples).
 */
import { WizardCard, StatusRow, KV, Pill } from "@/pages/wizard/_shared";
import ImplicitModellingPanel from "@/pages/wizard/ImplicitModellingPanel";
import WireframeEditorPanel from "@/pages/wizard/WireframeEditorPanel";


export default function DomainStep({ projectId, project, stats }) {
  const liths = stats?.geology?.lithologies || [];
  const nGeo = stats?.geology?.rows || 0;

  return (
    <div className="max-w-6xl space-y-4">
      {nGeo > 0
        ? <StatusRow tone="ok">
            <b>{liths.length} lithology code{liths.length === 1 ? "" : "s"}</b> detected
            across {nGeo.toLocaleString()} geology intervals.
          </StatusRow>
        : <StatusRow tone="warn">
            No geology CSV — the wizard will default to a single domain covering
            all assays. Upload a geology file on step 2 for domain-aware estimation.
          </StatusRow>}

      <WizardCard title="Detected lithologies" testId="w-domain-list">
        {liths.length === 0
          ? <div className="text-[12px] text-slate-500">No lithologies to display.</div>
          : (
            <div className="flex flex-wrap gap-1.5">
              {liths.map((l) => (
                <Pill key={l} tone="blue" testId={`w-domain-lith-${l}`}>{l}</Pill>
              ))}
            </div>
          )}
        <div className="pt-2">
          <KV k="Geology intervals" v={nGeo.toLocaleString()} />
          <KV k="Lithology codes"   v={liths.length} />
        </div>
      </WizardCard>

      <ImplicitModellingPanel projectId={projectId} project={project} stats={stats} />
      <WireframeEditorPanel projectId={projectId} />
    </div>
  );
}
